import React from "react";

export function Skeleton({ className = "" }) {
  return <div className={`skeleton ${className}`} />;
}

export function SkeletonCard() {
  return (
    <div className="w-card-flat p-6">
      <Skeleton className="h-3 w-24" />
      <Skeleton className="h-9 w-40 mt-4" />
      <Skeleton className="h-3 w-32 mt-3" />
    </div>
  );
}

export function SkeletonRows({ rows = 4 }) {
  return (
    <div className="w-card-flat overflow-hidden">
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="flex items-center justify-between px-4 py-4 border-b last:border-b-0"
          style={{ borderColor: "var(--border)" }}
        >
          <div className="flex-1">
            <Skeleton className="h-3 w-32" />
            <Skeleton className="h-3 w-20 mt-2" />
          </div>
          <Skeleton className="h-6 w-16" />
        </div>
      ))}
    </div>
  );
}
